import { styled, Card, CardContent, Typography, Box } from '@mui/material';

export const CardContentStyled = styled(CardContent)(({ theme }) => ({
  '&:last-child': {
    padding: theme.spacing(6),
  },
}));

export const TitleLabelStyled = styled(Typography)(({ theme }) => ({
  paddingBottom: theme.spacing(4),
})) as typeof Typography;

export const CardStyled = styled(Card)(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.grey[300]}`,
  boxShadow: 'none',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
})) as typeof Card;

export const InnerCardStyled = styled(Card)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(7),
  boxShadow: '0px 1px 10px 0px #0000003D',
  display: 'flex',
})) as typeof Card;

export const ActionWrapperStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'left',
  marginLeft: '2rem',
});

export const CheckboxOnlyWrapper = styled(Box)({
  width: '45px !important',
  height: '45px !important'
});
